import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import KpiCard from "../../../components/common/KpiCard";
import { getWorkEngagementDetail } from "../api/workApi";

const WorkEngagementDetail = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [engagement, setEngagement] = useState(null);

  useEffect(() => {
    loadEngagement();
  }, [id]);

  const loadEngagement = async () => {
    try {
      const res = await getWorkEngagementDetail(id);
      setEngagement(res.data);
    } catch (err) {
      console.error("Failed to load engagement", err);
    }
  };

  if (!engagement) return <div>Loading...</div>;

  const progress =
    engagement.totalChecklist > 0
      ? Math.round(
          (engagement.approvedChecklist / engagement.totalChecklist) * 100
        )
      : 0;

  return (
    <div className="space-y-6">

      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold">
          {engagement.ClientName}
        </h2>
        <p className="text-slate-500">
          {engagement.AssignmentName} • Assignment #{id}
        </p>
      </div>

      {/* KPI Section */}
      <div className="grid md:grid-cols-4 gap-4">
        <KpiCard label="Status" value={engagement.Status} />
        <KpiCard label="Progress" value={`${progress}%`} />
        <KpiCard label="Due Date" value={engagement.DueDate || "-"} />
        <KpiCard label="Checklist Items" value={engagement.totalChecklist} />
      </div>

      {/* Primary Actions */}
      <div className="flex gap-4">
        <button
          onClick={() => navigate("areas")}
          className="bg-indigo-600 text-white px-5 py-2 rounded-lg hover:bg-indigo-700"
        >
          Open Work Areas
        </button>
      </div>

    </div>
  );
};

export default WorkEngagementDetail;